import { useMutation } from "@tanstack/react-query";
import { getPaymentLink } from "../OrderService";
import { showToast } from "../../../../common/Toaster/Toaster";

const useGeneratePaymentLink = () =>
  useMutation({
    mutationFn: getPaymentLink,
    onSuccess: (paymentUrl) => {
      if (!paymentUrl) {
        showToast("Payment link is not available for this order", "error");
        return;
      }
      window.open(paymentUrl, "_blank", "noopener,noreferrer");
    },
    onError: (error) => {
      showToast(
        error?.response?.data?.error_message ||
          "Error while generating payment link",
        "error"
      );
    },
  });

export default useGeneratePaymentLink;
